module.exports = __webpack_public_path__ + "static/media/KneeC_N.d1da07e0.jpg";